import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SelectSearch from "react-select-search";
import "react-select-search/style.css";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Navbar from "../../Components/Navbar";
import "../../Assets/Styles/Availability/availability.scss";
import { formatNepaliDate, generateNepaliYears, getCurrentNepaliDate, getNepaliMonthNames } from "../../Hooks/useConvertNepaliDate";
import NepaliDate from "nepali-date-converter";
import NepaliDatePicker from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";

function Nepalidate() {
    const tableRef = useRef(null);
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { en: nepaliMonthhash, ne: nepaliEnglishMonths } = getNepaliMonthNames();
    const nepaliyearList = generateNepaliYears();

    const dropdownMontharray = [
        { name: 'Baishakh', value: 'Baishakh' },
        { name: 'Jestha', value: 'Jestha' },
        { name: 'Ashadh', value: 'Ashadh' },
        { name: 'Sharawan', value: 'Sharawan' },
        { name: 'Bhadra', value: 'Bhadra' },
        { name: 'Ashwin', value: 'Ashwin' },
        { name: 'Kartik', value: 'Kartik' },
        { name: 'Mangsir', value: 'Mangsir' },
        { name: 'Poush', value: 'Poush' },
        { name: 'Magh', value: 'Magh' },
        { name: 'Falgun', value: 'Falgun' },
        { name: 'Chaitra', value: 'Chaitra' }
    ];

    const [token, setToken] = useState("");
    const [currentYearINT, setcurrentYearINT] = useState("");
    const [currentMonthINT, setcurrentMonthINT] = useState("");
    const [selectedMonth, setselectedMonth] = useState("");
    const [dateSelectedState, setdateSelectedState] = useState(false);
    const [selectParticularDateState, setselectParticularDateState] = useState(false);
    const [allMonthSelectedState, setallMonthSelectedState] = useState(false);
    const [particularDateDataLoaded, setparticularDateDataLoaded] = useState(false);
    const [entireMonthScheduleArray, setentireMonthScheduleArray] = useState([]);
    const [particularMonthScheduleArray, setparticularMonthScheduleArray] = useState([]);
    const [selectedParticularMonth, setselectedParticularMonth] = useState("");
    const [particularErrorDetails, setparticularErrorDetails] = useState("");
    const [particularErrorState, setparticularErrorState] = useState(false);
    const [entireMonthErrorDetails, setentireMonthErrorDetails] = useState("");
    const [entireMonthErrorState, setentireMonthErrorState] = useState(false);
    const [selectedYear, setselectedYear] = useState("");
    const [yearSelected, setyearSelected] = useState(false);
    const [selectedDate, setSelectedDate] = useState(getCurrentNepaliDate().format('YYYY-MM-DD'));

    useEffect(() => {
        const tokenCheck = localStorage.getItem("tokens");
        if (!tokenCheck) {
            navigate("/");
        } else {
            setToken(tokenCheck);
        }
    }, [navigate]);

    const selectMonth = (monthname) => {
        setparticularErrorState(false);
        setentireMonthErrorState(false);
        setallMonthSelectedState(false);
        setselectParticularDateState(false);

        const monthKey = Object.keys(nepaliMonthhash).find(
            key => nepaliMonthhash[key] === monthname
        );

        setcurrentMonthINT(monthKey);
        setselectedMonth(monthname);
    };

    useEffect(() => {
        if (selectedMonth) {
            setdateSelectedState(true);
        }
    }, [selectedMonth]);

    const particularDateSelected = () => {
        setselectParticularDateState(true);
        setallMonthSelectedState(false);
    };

    const handleDateChange = (value) => {
        try {
            let date;

            // If value is an object with bsDate property (new format)
            if (value && typeof value === 'object' && value.bsDate) {
                // Convert Nepali digits to English if needed
                const englishDate = value.bsDate.replace(/[०-९]/g, d => '०१२३४५६७८९'.indexOf(d));
                const [year, month, day] = englishDate.split('-').map(Number);
                date = new NepaliDate(year, month - 1, day);
            }
            // If value is already a NepaliDate object
            else if (value instanceof NepaliDate) {
                date = value;
            }
            // If value is a string in YYYY-MM-DD format
            else if (typeof value === 'string') {
                const [year, month, day] = value.split('-').map(Number);
                date = new NepaliDate(year, month - 1, day);
            }
            // If value is a JavaScript Date object
            else if (value instanceof Date) {
                date = new NepaliDate(value);
            } else {
                console.error("Unknown date format:", value);
                return;
            }

            const formattedDate = date.format('YYYY-MM-DD');
            setSelectedDate(formattedDate);
            fetchParticularDateData(date);
        } catch (error) {
            console.error("Error handling date change:", error);
        }
    };

    const isSaturday = (dateString) => {
        if (!dateString) return false;

        try {
            const normalizedDate = dateString
                .replace(/[०-९]/g, d => '०१२३४५६७८९'.indexOf(d))
                .split('-')
                .map(Number);

            const [year, month, day] = normalizedDate;
            const nepaliDate = new NepaliDate(year, month - 1, day);
            return nepaliDate.getDay() === 6;
        } catch (error) {
            console.error("Error checking day for date:", dateString, error);
            return false;
        }
    };

    const fetchParticularDateData = (date) => {
        const bsDate = date.format('YYYY-MM-DD');
        setselectedParticularMonth(bsDate);

        axios.post(`${baseUrl}/schedulewithMiti`, {
            token: token,
            yearMonth: bsDate,
            typeRange: 'PARTICULAR'
        })
            .then((response) => {
                setparticularMonthScheduleArray(response?.data);
                setparticularDateDataLoaded(true);
                setparticularErrorState(false);
            })
            .catch((error) => {
                setparticularErrorDetails("No data available.");
                setparticularErrorState(true);
                setparticularDateDataLoaded(false);
            });
    };

    const entireMonthSelected = () => {
        setentireMonthErrorState(false);
        setparticularErrorState(false);
        setparticularDateDataLoaded(false);
        setselectParticularDateState(false);
        setallMonthSelectedState(true);

        if (currentYearINT && currentMonthINT) {
            const entireMonthString = `${currentYearINT}-${currentMonthINT}`;

            axios.post(`${baseUrl}/schedulewithMiti`, {
                token: token,
                yearMonth: entireMonthString,
                typeRange: 'ALL'
            })
                .then((response) => {
                    const responsearray = response?.data.sort((a, b) =>
                        new Date(a.reservationMitiFor) - new Date(b.reservationMitiFor)
                    );
                    setentireMonthScheduleArray(responsearray);
                })
                .catch((error) => {
                    setentireMonthErrorDetails("No data available.");
                    setentireMonthErrorState(true);
                });
        }
    };

    const selectedYearlist = (e) => {
        setselectedYear(e);
        setcurrentYearINT(e);
        setyearSelected(true);
    };

    const parseDateObject = (datestring) => {
        return new Date(datestring).toISOString().slice(0, 10);
    };

    const renderTable = (data) => (
        <table className="table table-striped" ref={tableRef}>
            <thead>
                <tr>
                    <th>ReservationID</th>
                    <th>Name</th>
                    <th>reservationMitiFor</th>
                    <th>Pax</th>
                    <th>reservationForDate</th>
                    <th>reservationDate</th>
                    <th>reservationMiti</th>
                    <th>Timeslot</th>
                    <th>PaymentStauts</th>
                    <th>Billno</th>
                    <th>TotalDue</th>
                    <th>
                        <div className="col-1">
                            <small>Payment</small>
                            <small className="text-muted">(Excluding Advance)</small>
                        </div>
                    </th>
                    <th>AdvanceAmount</th>
                    <th>RemainingAmount</th>
                </tr>
            </thead>
            <tbody>
                {data.map((info, index) => {
                    return (
                        <tr key={index}>
                            <th scope="row">{info.banquetReservationID || ""}</th>
                            <td>{info.customerName || ""}</td>
                            <td>
                                {info.reservationMitiFor || ""}
                            </td>
                            <td>{info.paxCount || ""}</td>
                            <td>{parseDateObject(info.reservationForDate) || ""}</td>
                            <td>{parseDateObject(info.reservationDate) || ""}</td>
                            <td>{info.reservationMiti || ""}</td>
                            <td>{info.timeslot || ""}</td>
                            <td>
                                {info.paymentStauts === "None"
                                    ? "No payment yet"
                                    : info.paymentStauts || "No payment made"}
                            </td>
                            <td>{info?.paymentDetails?.billno || "Not billed"}</td>
                            <td>{info?.paymentDetails?.TotalCredit || ""}</td>
                            <td>{info?.paymentDetails?.TotalPaymentMade || ""}</td>
                            <td>{info?.paymentDetails?.AdvanceAmount || ""}</td>
                            <td>{info?.paymentDetails?.RemainingAmount || ""}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

    return (
        <div>
            <Navbar />
            <div className="date-select">
                <SelectSearch
                    options={nepaliyearList}
                    onChange={selectedYearlist}
                    name="yearList"
                    placeholder="Choose the year"
                    value={selectedYear}
                />
                {yearSelected && (
                    <SelectSearch
                        options={dropdownMontharray}
                        onChange={selectMonth}
                        name="MonthList"
                        placeholder="Choose the month"
                        value={selectedMonth}
                    />
                )}
            </div>

            {dateSelectedState && (
                <div className="">
                    <div className="selectbuttons">
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={entireMonthSelected}>
                            Entire Month
                        </button>
                        <button
                            type="button"
                            className="btn btn-info"
                            onClick={particularDateSelected}>
                            Select Date
                        </button>
                    </div>

                    {!entireMonthErrorState && allMonthSelectedState && (
                        <div className="entireMonthselectedDiv">
                            <div className="monthly">
                                <div className="selectedmonthname">{selectedMonth}</div>
                                <DownloadTableExcel
                                    filename="Availability table"
                                    sheet="Availability table"
                                    currentTableRef={tableRef.current}>
                                    <button> Export to Excel </button>
                                </DownloadTableExcel>
                                <div className="monthlytable">
                                    <div className="table-responsive text-nowrap">
                                        {renderTable(entireMonthScheduleArray)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {entireMonthErrorState && (
                        <div className="monthlyerror d-flex justify-content-center mt-5">
                            {entireMonthErrorDetails}
                        </div>
                    )}

                    {selectParticularDateState && (
                        <div className="d-flex justify-content-center mt-5">
                            <NepaliDatePicker
                                value={selectedDate}
                                onChange={(value) => handleDateChange(value)}
                                options={{
                                    calenderLocale: 'ne',
                                    valueLocale: 'en',
                                    closeOnSelect: true
                                }}
                                inputClassName="form-control"
                                className="nepali-date-picker"
                            />
                        </div>
                    )}

                    {selectParticularDateState && particularDateDataLoaded && (
                        <div className="particulardateDataLoaded">
                            <div className="container">
                                <div className="particularMonth">
                                    {formatNepaliDate(new NepaliDate(selectedDate), 'YYYY-MM-DD')}
                                </div>
                            </div>
                            <div className="table-responsive text-nowrap">
                                {renderTable(particularMonthScheduleArray)}
                            </div>
                        </div>
                    )}

                    {particularErrorState && (
                        <div className="d-flex justify-content-center mt-5 particularerror">
                            {particularErrorDetails}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default Nepalidate;